const CHANNEL_NAME = "estbn_auth_channel";

export function initSessionSync({ getSession, onSessionReceived }) {
    if (typeof BroadcastChannel === "undefined") {
        return { requestSession: () => { }, channel: null };
    }

    const channel = new BroadcastChannel(CHANNEL_NAME);

    channel.addEventListener("message", (event) => {
        const { type, payload } = event.data || {};

        if (type === "SESSION_REQUEST") {
            const session = getSession();
            if (session) {
                channel.postMessage({ type: "SESSION_RESPONSE", payload: session });
            }
        }

        if (type === "SESSION_RESPONSE") {
            onSessionReceived(payload);
        }
    });

    function requestSession() {
        channel.postMessage({ type: "SESSION_REQUEST" });
    }

    return { requestSession, channel };
}